// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"196":"a254b460","327":"a60e5eb5","535":"99345c34","888":"2bc2fa51"}[chunkId] + ".css";
};